import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
    Progress,
    message,
} from 'antd'
import { firestore, firStorage } from '../../../service/firebase'
import './Picture.scss'

const { TextArea } = Input


export default class Picture extends React.Component {

    page = 'images'
    
    columns = [
        { title: "Logo", dataIndex: 'url', key: 'url', render: url => {
            if(url) {
                return <img src={url} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
            } else {
                return <img src={require('../../../assets/img_placeholder.png')} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
            }
        } },
        { title: "Title", dataIndex: 'title', key: 'title' },
        { title: "Description", dataIndex: 'description', key: 'description' },
        // { title: "Poster", dataIndex: 'poster', key: 'poster' },
        { title: "Likes", dataIndex: 'likes', key: 'likes', render: likes => {
            let likesCount = 0
            if(likes) {
                likesCount = Object.keys(likes).length
            }

            return <span>{likesCount}</span>
        } },
        { title: 'Actions', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    // dictPoster = { admin: 'Admin User' }

    state = {
        showModal: false,
        uploadState: 0,
        downloadURL: '',
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Images')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth())
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            id: '',
            url: null,
            title: '',
            description: '',
            showModal: true,
            uploadState: 0,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        this.editItem = item
        let state = this.state

        let newState = Object.assign(state, item, {
            showModal: true,
            uploadState: 2,
        })

        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('Images').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('Images').doc()
            id = ref.id
        } else {
            ref = firestore.collection('Images').doc(id)
        }

        let object = {
            id,
            title: state.title ? state.title : '',
            description: state.description ? state.description : '',
            url: state.url ? state.url : '',
            updated: new Date(),
        }

        if(this.eventEdit) {
            object['poster'] = this.editItem['poster']
        } else {
            object['poster'] = 'admin'
        }

        console.log(state, object)

        if(this.eventEdit) {
            ref.update(object)
        } else {
            ref.set(object)
        }
        
        this.setState({showModal: false})
    }

    handleClose() {
        this.setState({showModal: false})
    }


    /*-----------------Upload Image-------------------*/

    handleUpload(input) {
        input.click();
    }

    onChangeFile(evt) {
        let orgName = evt.target.files[0].name;
        let key = Date.now();
        let fileName = this.page + "_" + key + "." + orgName.substring(orgName.length - 3);
        let path = '/' + this.page + '/' + fileName;
        this.uploadFile(evt.target.files[0], path);
    }
    
    uploadFile(file, path) {
        if(this.state.uploadState === 1) {
            return;
        }

        this.setState({uploadState: 1});

        var uploadTask = firStorage.ref().child(path).put(file);
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({uploadProgress: progress});
            console.log('Upload is ' + progress + '% done');
        }, (error) => {
            this.setState({uploadState: 0});
            message.error("Failed on uploading image! Try again please!");
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                this.setState({
                    uploadState: 2,
                    url: downloadURL
                });
            });
        });
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/

    renderCellDetail(row) {
        return(
            <Row className="cell">
                <div className="img">
                {
                    row.url ? 
                        <img src={row.url} alt="IMG-LOGO" /> :
                        <img src={require('../../../assets/img_placeholder.png')} alt="IMG-LOGO" />
                }
                </div>

                <div className="content">
                    <div className="content-row"><div className="caption"><b>Title :</b></div>{row.title}</div>
                    <div className="content-row"><div className="caption"><b>Likes :</b></div> {row.likes ? Object.keys(row.likes).length : '0'}</div>
                    <div className="content-row"><div className="caption"><b>Poster :</b></div> {row.poster ? row.poster : '-'}</div>
                    <div style={{margin: '20px 5px 5px 5px', display: 'flex'}}><div className="caption"><b>Description :</b></div></div>
                    <div style={{margin: 5, marginLeft: 100}}>{row.description}</div>
                </div>
            </Row>
        )
    }

    
    render() {

        return (
            <div className="personal-taste">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Image</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    expandedRowRender={record => this.renderCellDetail(record)} 
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title={this.eventEdit ? 'Edit Pictures & Images' : "Add Pictures & Images"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Title</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Description</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.description} onChange={evt => this.handleChange('description', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Logo Image</div>
                        <div style={{cursor: 'pointer'}} onClick={() => this.handleUpload(this.logoInput)}>
                        {
                            this.state.uploadState === 0 ?
                                <div className="logo-placeholder">Logo</div> :
                            this.state.uploadState === 1 ?
                                <div style={{margin: 20}}>
                                    <Progress type="circle" percent={this.state.uploadProgress ? Number(this.state.uploadProgress.toFixed(2)) : 0} />
                                </div> :
                                <div className="logo-img">
                                    <img src={this.state.url} alt="IMG-LOGO" />
                                </div>
                        }
                        </div>
                    
                        <input type="file" className="file-input"
                            ref={input => this.logoInput = input}
                            onChange={evt => this.onChangeFile(evt)}
                            accept="image/x-png,image/gif,image/jpeg" />

                    </Row>

                </Modal>

            </div>
        )
    }
}
